exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".therapist-picture[data-v-20383aab] {\n  border-radius: 50%;\n  width: 4rem;\n  height: 4rem;\n  border: solid 3px #ffffff;\n  right: 0;\n  top: -0.5rem;\n}\n.therapist-line[data-v-20383aab] {\n  background-color: #e8e8e8;\n  max-height: 3rem;\n}", ""]);

// exports
